import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a557500")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    custom: "",
    to: _ctx.props.path
  }, {
    default: _withId(({ href, navigate, isActive, isExactActive }) => [
      _createVNode("li", {
        class: ["item", { 'router-link-active': isActive, 'router-link-exact-active': isExactActive, 'desktop-only': _ctx.desktopOnly }]
      }, [
        _createVNode("a", {
          class: "link",
          href: href,
          onClick: [() => navigate(_ctx.$event), _ctx.closeNavigation]
        }, _toDisplayString(_ctx.routeName), 9, ["href", "onClick"])
      ], 2)
    ]),
    _: 1
  }, 8, ["to"]))
})